import React, { FC } from 'react';

import DatasetElementView from 'editors/PushNotificationEditor/Editor/components/DatasetElementView';
import styled from 'styled-components';

import aampeTheme from '../../../../constants/aampeTheme';

import { DatasetModel } from 'models/dataset.model';
import { DatasetElement } from 'models/editor.model';

interface DatasetContentProps {
    child: DatasetElement;
    datasetData: DatasetModel;
}

const DatasetContent: FC<DatasetContentProps> = ({ child, datasetData }) => {
    const datasetField = child.datasetField;
    const sampleValue = datasetData?.fields.find(
        (field) => field.id == datasetField,
    )?.sample;

    return (
        <StyledDatasetElementView
            aampeToolTipTitle=""
            datasetFieldSample={(sampleValue as string) || ''}
        />
    );
};

const StyledDatasetElementView = styled(DatasetElementView)({
    userSelect: 'none',
    outline: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    borderRadius: aampeTheme.borderRadius.default,
    backgroundColor: aampeTheme.colors.interactiveWG01,
    padding: aampeTheme.spacing4(0, 1),
    color: aampeTheme.colors.neutral09,
    lineHeight: aampeTheme.size.lineHeight.default,
    fontSize: aampeTheme.size.font.textMedium,
    fontWeight: 400,
    minWidth: '30px',
    border: `1px solid ${aampeTheme.colors.solidA02}`,
});

export default DatasetContent;
